__turbopack_context__.v({
  "freeShipping": "hg9moq_freeShipping",
});
